import client from "./client";

export default {
    async getModules(filters) {
        return client.parseResponse(await client.get('/modules', filters));
    },
    async getModule(id) {
        return client.parseResponse(await client.get('/modules/' + id));
    },
}
